module.exports = __webpack_public_path__ + "static/media/tree_10.5bb1150b.jpg";